import React from "react";
import PropTypes from "prop-types";
import { StyledChartsGroup } from "../../../../../common/styles/ChartsStyles";
import AgeChart from "../../../../../components/atoms/charts/AgeChart";
import Chart from "../../../../../components/atoms/charts/Chart";

const Charts = ({ data }) => {
  if (!data) return null;
  const {
    age_freq: age,
    cancer_name: cancerName,
    cancer_type: cancerType,
    country,
    grade,
    infectious_agent: infectiousAgent,
    oncotree_code: oncotreeCode,
    sample_source: sampleSource,
    sex,
    stage,
    race,
    tissue_type: tissueType,
  } = data;

  return (
    <StyledChartsGroup>
      <AgeChart showEmptyState={false} data={age} title="Age frequency" />
      <Chart showEmptyState={false} data={cancerType} title="Cancer type" />
      <Chart showEmptyState={false} data={cancerName} title="Cancer name" />
      <Chart showEmptyState={false} data={country} title="Country" />
      <Chart data={grade} title="Grade" showEmptyState={false} />
      <Chart
        showEmptyState={false}
        data={infectiousAgent}
        title="Infectious agent"
      />
      <Chart showEmptyState={false} data={oncotreeCode} title="Oncotree code" />
      <Chart data={race} title="Race" showEmptyState={false} />
      <Chart showEmptyState={false} data={sampleSource} title="Sample source" />
      <Chart showEmptyState={false} data={sex} title="Sex" />
      <Chart showEmptyState={false} data={stage} title="Stage" />
      <Chart showEmptyState={false} data={tissueType} title="Tissue type" />
    </StyledChartsGroup>
  );
};

Charts.propTypes = {
  data: PropTypes.shape({
    age_freq: PropTypes.arrayOf(
      PropTypes.shape({
        key: PropTypes.string,
        value: PropTypes.number,
      })
    ),
    cancer_name: PropTypes.arrayOf(
      PropTypes.shape({
        key: PropTypes.string,
        value: PropTypes.number,
      })
    ),
    cancer_type: PropTypes.arrayOf(
      PropTypes.shape({
        key: PropTypes.string,
        value: PropTypes.number,
      })
    ),
    country: PropTypes.arrayOf(
      PropTypes.shape({
        key: PropTypes.string,
        value: PropTypes.number,
      })
    ),
    grade: PropTypes.arrayOf(
      PropTypes.shape({
        key: PropTypes.string,
        value: PropTypes.number,
      })
    ),
    infectious_agent: PropTypes.arrayOf(
      PropTypes.shape({
        key: PropTypes.string,
        value: PropTypes.number,
      })
    ),
    oncotree_code: PropTypes.arrayOf(
      PropTypes.shape({
        key: PropTypes.string,
        value: PropTypes.number,
      })
    ),
    sample_source: PropTypes.arrayOf(
      PropTypes.shape({
        key: PropTypes.string,
        value: PropTypes.number,
      })
    ),
    sex: PropTypes.arrayOf(
      PropTypes.shape({
        key: PropTypes.string,
        value: PropTypes.number,
      })
    ),
    stage: PropTypes.arrayOf(
      PropTypes.shape({
        key: PropTypes.string,
        value: PropTypes.number,
      })
    ),
    race: PropTypes.arrayOf(
      PropTypes.shape({
        key: PropTypes.string,
        value: PropTypes.number,
      })
    ),
    tissue_type: PropTypes.arrayOf(
      PropTypes.shape({
        key: PropTypes.string,
        value: PropTypes.number,
      })
    ),
  }),
};

Charts.defaultProps = {
  data: null,
};
export default Charts;
